import { IRootState } from 'app/shared/reducers';
import { createSelector } from 'reselect';
import { AccountState } from './state';

const selectAccountState: any = (state: IRootState) => state.account;

export const subList = createSelector<IRootState, AccountState, any>(selectAccountState, (account: AccountState) =>
  (account.subcriptionNotAttachedList || []).filter(s => s.valid === false)
);

export const selectContract = createSelector<IRootState, AccountState, any>(
  selectAccountState,
  (account: AccountState) => account.selectedContract
);
